// extracted by mini-css-extract-plugin
export default {"list":"style_list__JV92B","list__item":"style_list__item__p5A8y"};